<div  [ngClass]="{'shipmentCell' : isShipment}">
  <div class="shipment_star " *ngIf="isShipment" [ngClass]="{'active': params?.IsStarred || params?.isStarred}">
    <i class="fas fa-star"></i>
  </div>
  <div class="order-info">
    <div class="d-flex align-items-baseline">
       <div class="order-info_order-id mb-0" >
         <a *ngIf="!isShipment" class="hand" [ngClass]="{'cursor' : params.ShipTo?.toLowerCase() !== 'amazon'}" (click)="openLink($event,params,isShipment)"> {{params.amazonShipmentId
           ? params.amazonShipmentId
           : params.ShipmentId ? params.ShipmentId : "Draft: " + params.shipmentHeaderId }} </a>
           <a *ngIf="isShipment" class="hand" [ngClass]="{'cursor' : params.ShipTo?.toLowerCase() !== 'amazon'}" (click)="openLink($event,params,isShipment)"> 
            {{  params.ShipmentId && params.Status != 'DRAFT'
            ? params.ShipmentId
            : "Draft: " + params.shipmentHeaderId}} </a>
          <i
            class="fal"
            [ngClass]="{ 'fa-copy': !copied, 'fa-check': copied }"
            [cdkCopyToClipboard]="params.ShipmentId ? params.ShipmentId : 'Draft: ' +params.shipmentHeaderId"
            (cdkCopyToClipboardCopied)="copy($event)"
          ></i>
        </div>
        <span *ngIf="isShipmentInfo || (isShipment && !isWalmart && params.Status != 'DRAFT')"
        class="order-info_order-link ms-1"
        (click)="openOnAmazon($event)"
      >
        <i class="fal fa-external-link-square-alt"></i>
      </span>
      <span *ngIf="isShipmentInfo" (click)="searchInput(params.ShipmentId)" class="order-info_order-link ms-2">
        <i class="fal fa-search"></i>
      </span>
     </div>
     <div [ngClass]="{'shipment-gridCell' : isShipmentInfo}">
       <div class="order-info_order-date d-flex align-items-center justify-content-between" *ngIf="!isShipment">
         {{params.ShipmentName}}
      </div>
      <div class="order-info_order-date d-flex align-items-center justify-content-between" *ngIf="isShipment">
       <span [matTooltip]="!params.isSuccess ? params.errorMessage : ''" [ngClass]="params.shipmentName == 'Shipment was not created' ? 'error' : ''">{{params.ShipmentName}}</span>    
        <div class="freemium ms-2" [ngClass]="{'freemium--active':params.isFreemium}"></div>
       </div>
       <!-- <span class="shipment_relatedShipment font_size_12" *ngIf="params?.RelatedShipment > 0  && isShipment">
        <span >
          {{ params?.RelatedShipment }} Related Shipments
        </span>
      </span> -->
       <span class="order-info_data" *ngIf="isShipmentInfo && !isShipment">
         <label class="element-bullets">FC : <span>{{params.Code}}</span></label>
       </span>
     </div>
   </div>
</div>
  
